import Router from '../router'
import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (getToken()) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['authorization'] = 'Bearer ' + getToken()
    }
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (res.status != 200 && res.status != 0 && res.code != 0 && (!res.status && !res.code && res.data)) {
      Message({
        message: res.msg || '网络请求失败',
        type: 'error',
        duration: 5 * 1000
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
        })
      }
      return Promise.reject(new Error(res.message || '网络请求失败'))
    } else {
      return res
    }
  },
  error => {
     if (error.config.url.indexOf('/logout') < 0) {
       if (!window.sessionStorage.getItem('isErrorMessage')) {
           Message({
             message: error.response.status === 401 ? '登录超时' : error.message,
             type: 'error',
             duration: 5 * 1000
           })
           window.sessionStorage.setItem('isErrorMessage', true);

           setTimeout(() => {
             window.sessionStorage.removeItem('isErrorMessage')
           }, 1000)
        }

       // 登录超时等异常后退出登录
       if ((getToken() && error.message === 'Network Error') || error.response.status === 401) {
         store.dispatch('logout')
         const path = Router.currentRoute.fullPath
         Router.push(`/login?redirect=${path}`)
       }
     }

    return Promise.reject(error)
  }
)

export default service
